module.exports = __webpack_public_path__ + "video.jpg?a83ad30";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/video.jpg
 ** module id = 67
 ** module chunks = 0
 **/